import { getRequest } from '@/core';
import { orders } from '@/requests';

export default async function getOrderByQuickSearchRequest(text) {
	let url = orders.getByQuickSearchPath(text);
	let response = await getRequest(url);
	return response;
}
